<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" view-box="0 0 40 40" width="40" height="40" fill="none">
      <mask
        id="RfWebtrafficMask"
        width="40"
        height="40"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
      >
        <path fill="#d9d9d9" d="M0 0h40v40H0z" />
      </mask>
      <g mask="url(#RfWebtrafficMask)">
        <path
          fill="inherit"
          stroke="none"
          d="M3.85 19.25v-1.4h5.08v1.4zm4.82 9.57-.97-.98 3.55-3.54.96.96zm2.58-16.06L7.7 9.22l.97-.98 3.54 3.55zm17.28 18.08-7.37-7.37-1.51 4.66L16.2 16.6l11.57 3.53-4.69 1.68 7.25 7.25zm-11.2-20.76V5h1.41v5.08zm7.51 2.68-.97-.97 3.55-3.55.97 1z"
        />
      </g>
    </svg>
  </span>
</template>
